/* eslint-disable react/no-unescaped-entities */
// @flow
/* eslint-disable react/no-danger */
import * as React from 'react';
import classNames from 'classnames';

import { type EnhancedProps, withTransition } from 'client/components/common/HOCs/with-transition';
// import bgImg from 'assets/client/bg.png';
// import bgMelodies from 'assets/client/melodies_bg.png';
import { Header, Footer } from 'client/components/common';

import * as css from './VotesEnded.scss';

type Props = {|
	...EnhancedProps,
	in: boolean,
|};

type State = {};

class VotesEnded extends React.PureComponent<Props, State> {
	transitionCompleteTimeout: TimeoutID;

	componentDidMount() {
		const { onTransitionComplete } = this.props;
		this.transitionCompleteTimeout = setTimeout(onTransitionComplete, parseInt(css.transitionIn, 10));
	}

	componentDidUpdate(prevProps: Props) {
		if (this.props.in !== prevProps.in) {
			const { onTransitionComplete } = this.props;
			let duration = parseInt(this.props.in ? css.transitionIn : css.transitionOut, 10);

			if (!this.props.in) {
				duration = 0;
			}
			clearTimeout(this.transitionCompleteTimeout);
			this.transitionCompleteTimeout = setTimeout(onTransitionComplete, duration);
		}
	}

	render() {
		const { transitionState } = this.props;

		return (
			<div className={classNames(css.thanks, css[transitionState])}>
				<Header />
				{/* <div className={css.bgMelodies} style={{ backgroundImage: `url(${bgMelodies})` }}></div> */}
				<div className={css.content}>
					<div className={css.contentRight}>
						<div className={css.text}>
							<h2>תודה על השתתפותכם</h2>
							<p>
								תוצאות המצעד יחשפו בשידור חי מאולפן ynet&nbsp;
								<br />
								<span>22 בספטמבר בין השעות 13:00 – 16:00</span>
							</p>
						</div>
					</div>
				</div>
				<Footer />
			</div>
		);
	}
}

export default withTransition(VotesEnded);
